module.exports = __webpack_public_path__ + "static/media/6.fcd00071.svg";